/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ready: NonNullable<unknown>, total: NonNullable<unknown> }} Deft_Dry_Eel_WalkInputs */

const en_deft_dry_eel_walk = /** @type {(inputs: Deft_Dry_Eel_WalkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ready} / ${i?.total} available`)
};

const de_deft_dry_eel_walk = /** @type {(inputs: Deft_Dry_Eel_WalkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ready} / ${i?.total} verfügbar`)
};

/**
* | output |
* | --- |
* | "{ready} / {total} available" |
*
* @param {Deft_Dry_Eel_WalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_dry_eel_walk = /** @type {((inputs: Deft_Dry_Eel_WalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_Dry_Eel_WalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_dry_eel_walk(inputs)
	return de_deft_dry_eel_walk(inputs)
});